/* DON'T EDIT THIS FILE: edit original and run build again */ import { Sidebar } from "../../framework/theme-pages/sidebar.front.tsx";
import { Container } from "react-bootstrap";

export const PageBorder = ({
  children = null,
  footer = null,
  infoSidebar = null,
  extraHeader = null,
  newRawPageBorder = false,
  extraHeaderClassName,
  current = undefined,
  container = true,
}: {
  container?: boolean;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  infoSidebar?: React.ReactNode;
  extraHeader?: React.ReactNode;
  newRawPageBorder?: boolean;
  extraHeaderClassName?: string;
  current?: string;
}) => {
  const RawBorder = newRawPageBorder ? RawPageBorderNew : RawPageBorder;
  return (
    <div className="d-flex flex-row bg-primary">
      <div className="d-print-none bg-inverted-secondary">
        <Sidebar current={current} />
      </div>
      <div className="flex-grow-1 ">
        <RawBorder
          extraHeader={extraHeader}
          minHeight="100vh"
          headerClassName={extraHeaderClassName}
        >
          <div className="d-flex bg-primary align-items-stretch flex-grow-1 pb-4 overflow-x-auto">
            {infoSidebar}
            <div className="d-flex align-items-stetch flex-grow-1 width-without-sidebar">
              {container ? (
                <Container className="d-flex flex-column align-items-center">
                  {children}
                </Container>
              ) : (
                children
              )}
            </div>
          </div>
          {footer}
        </RawBorder>
      </div>
    </div>
  );
};

export const SimplePageBorder = ({
  children,
  extraHeader,
}: {
  children: React.ReactNode;
  extraHeader?: React.ReactNode;
}) => (
  <div className="d-flex flex-row bg-primary">
    <div className="flex-grow-1 ">
      <RawPageBorder extraHeader={extraHeader} minHeight="100vh">
        <div className="d-flex bg-primary align-items-stretch flex-grow-1 pb-2 overflow-x-auto">
          <div className="flex-grow-1">
            <div className="py-4">
              <Container className="d-flex flex-column align-items-center">
                {children}
              </Container>
            </div>
          </div>
        </div>
      </RawPageBorder>
    </div>
  </div>
);

export const RawPageBorder = ({
  children,
  extraHeader,
  height = undefined,
  minHeight = undefined,
  backgroundColor = undefined,
  headerClassName = "",
}: {
  children: React.ReactNode;
  extraHeader?: React.ReactNode;
  height?: string;
  minHeight?: string;
  backgroundColor?: string;
  headerClassName?: string;
}) => {
  return (
    <div
      className={"d-flex flex-column align-items-stretch bg-primary"}
      style={{ /* FIXME@UX */ height, minHeight, background: backgroundColor }}
    >
      <div
        className="d-print-none"
        style={{
          /* FIXME@UX */ position: "sticky",
          top: 0,
          zIndex: 999,
        }}
      >
        {extraHeader ? (
          <div className={headerClassName}>{extraHeader}</div>
        ) : null}
      </div>
      {children}
    </div>
  );
};

export const RawPageBorderNew = ({
  children,
  extraHeader,
  height = undefined,
  minHeight = undefined,
  backgroundColor = undefined,
  headerClassName = "bg-secondary",
}: {
  children: React.ReactNode;
  extraHeader?: React.ReactNode;
  height?: string;
  minHeight?: string;
  backgroundColor?: string;
  headerClassName?: string;
}) => {
  return (
    <div
      className={"d-flex flex-column align-items-stretch "}
      style={{ /* FIXME@UX */ height, minHeight, background: backgroundColor }}
    >
      {extraHeader && (
        <div className={headerClassName}>
          <Container className="d-print-none d-flex flex-column align-items-center">
            {extraHeader}
          </Container>
        </div>
      )}
      {children}
    </div>
  );
};

export const FixedHeightPageBorder = ({
  children,
  extraHeader,
  current,
  extraHeaderClassName,
}: {
  children: React.ReactNode;
  extraHeader: React.ReactNode;
  extraHeaderClassName?: string;
  current: string;
}) => (
  <div className="d-flex flex-row">
    <div className="d-print-none bg-inverted-secondary">
      <Sidebar current={current} />
    </div>

    <div className="flex-grow-1">
      <RawPageBorder
        extraHeader={extraHeader}
        headerClassName={extraHeaderClassName}
        height="100vh"
      >
        {children}
      </RawPageBorder>
    </div>
  </div>
);
